module.exports = __webpack_public_path__ + "img/th_th.6163d4f0.png";